import React, { Component } from "react";
import PropTypes from "prop-types";

import { hideModal } from "../../../../usecases/commons/hide-modal";
import { deleteBenefitModel } from "../../../../usecases/benefit-model/delete-benefit-model";
import { translate as t } from "../../../../infrastructure/translate/localization";

import CircleButton from "../../commons/CircleButton";
import "./removeBenefitsModal.scss";

class RemoveBenefitsModal extends Component {
  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
    hideModal();
  }

  handleAccept = async (benefitId) => {
    await deleteBenefitModel(benefitId);
    hideModal();
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.handleAccept();
    }
  };

  render() {
    const { benefitName, benefitModalId } = this.props;
    return (
      <div className="modal-container">
        <CircleButton
          className="primary close-modal"
          icon="times"
          handlerClick={() => hideModal()}
        />
        <div className="remove-benefits">
          <div className="modal-title">
            <p className="title">{t("benefits-section.remove-model")}</p>
          </div>
          <div className="modal-section">
            <p className="section-text">
              {t("benefits-section.remove-model-sure", {
                benefitName,
              })}
            </p>
          </div>

          <div className="buttons-group">
            <button
              type="button"
              className="btn-line btn-little gray"
              onClick={() => hideModal()}
            >
              {t("actions.cancel")}
            </button>

            <button
              type="button"
              className="btn-line btn-little primary"
              onClick={() => this.handleAccept(benefitModalId)}
            >
              {t("actions.delete")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

RemoveBenefitsModal.propTypes = {
  benefitModalId: PropTypes.string.isRequired,
  benefitName: PropTypes.string.isRequired,
};

export default RemoveBenefitsModal;
